import { useContext, useEffect, useState } from "react";
import { AuthContext } from "context/AuthContext";
import TopNav from "ui/dashboard/topnav";
import { fetchSites } from "lib/actions";
import { showToast } from "ui/components/common";
import SiteCollapse from "./components/site-collapse";
import "./page.scss";

export default function Page() {
  const { user } = useContext(AuthContext);

  const [sites, setSites] = useState([]);

  useEffect(() => {
    fetchSiteData();
  }, []);

  const fetchSiteData = async () => {
    try {
      const siteData = await fetchSites(user.token, user.orgId);
      setSites(siteData);
    } catch (error) {
      console.error("Error fetching sites:", error);
      showToast(1, "Failed to fetch Site list. Please try again later.");
    }
  };

  return (
    <>
      <TopNav title="Camera List" />
      <div className="flex h-full flex-col md:flex-row md:overflow-hidden mr-6 mb-6 bg-white rounded-3xl">
        <div className="w-full px-6 my-6 overflow-auto">
          {sites.map((site) => (
            <SiteCollapse key={site.id} site={site} />
          ))}
        </div>
      </div>
    </>
  );
}
